import { validatePaymentMode } from "../../collectPayment/selectPaymentMode/components/constant";

//pseudo validation functions as we need to bypass validations for the "Exam charges" module
export const validateExamChargesPaymentMode = (...args) => validatePaymentMode(...args, true);
export const validateSequencing = () => true;
export const reviewReceipt = () => true;


const updateChargeForReq = charge => {
    const {
        dueDate,
        term,
        courseId,
        itemType,
        basePrice : totalGrossAmount,
        netPayableAmount : totalNetPayableAmount,
        finalPayable : totalBalanceAmount,
        waveOffAmount : totalConcessionApplied,
        status,
        cgst,
        sgst,
        igst,
        utgst,
        taxes,
    } = charge;

    return {
        dueDate,
        term,
        courseId,
        itemType,
        itemTypeList : [itemType],
        totalGrossAmount,
        totalNetPayableAmount,
        totalBalanceAmount,
        totalConcessionApplied,
        status,
        cgst,
        sgst,
        igst,
        utgst,
        taxes,
        //fields with static values
        installmentNo : 0,
        totalPaidAmount : 0,
        isAutoSelect : false,
        failedChequeHistory : false,
        itemTypeWiseInstallmentsList : "",
        securityChargeTypeId : null,
        applicationQuotationId : 0,
        year : null,
        pserpId : null
    }
}


export const getCreateExamReceiptReqObj = (
  studentBasicDetails,
  amountToBePaid,
  selectedCharges,
  collectPayment = [],
  collectVoucherList = []
) => {
  const {
    rollNumber : examRollNumber,
    psid,
    buId,
    examOtherChargeId,
    bu,
  } = studentBasicDetails;
  const appliedErpVouchers = collectVoucherList?.filter(
    (voucher) => voucher?.voucherType === "ERP"
  );
  const appliedPhoenixVouchers = collectVoucherList?.filter(
    (voucher) => voucher?.voucherType === "PHX"
  );
  let paymentModeCollectionRequestList = [
    ...collectPayment,
    ...appliedErpVouchers,
  ]?.map((el) => ({
    ...el,
    referenceNumber: (el?.referenceNumber?.label ?? el?.referenceNumber) || "",
  })); // remove cardsPayment from paymentModeCollectionRequestList
  const cardsPayments = paymentModeCollectionRequestList.filter(
    (payment) => payment?.isRemoveFromRequest
  );
  paymentModeCollectionRequestList = paymentModeCollectionRequestList.filter(
    (payment) => !payment?.isRemoveFromRequest
  );

//   const isEpmrEnabled = epmrDetails(studentBasicDetails) ? true : false;
  const request = {
    examRollNumber,
    psid,
    businessAreaId: buId,
    businessAreaDispValue: bu,
    applicationQuotationId : 0,
    isEpmrEnabled: false,
    // opportunityOwnerId: studentBasicDetails?.opportunityOwnerId,
    isUpfrontCase : false,
    totalAmountSelected: amountToBePaid,
    paymentModeCollectionRequestList:
      paymentModeCollectionRequestList.length > 0
        ? paymentModeCollectionRequestList
        : null,
    otherChargesDtoList: selectedCharges["OTHER_CHARGES"]?.map(charge => updateChargeForReq(charge)),
    // regularChargesDtoList: selectedCharges["REGULAR_CHARGES"],
    // phoenixNonReceiptedIds: appliedPhoenixVouchers?.map(
    //   (voucher) => voucher?.vId
    // ),
     paymentVoucherDtoList : appliedPhoenixVouchers?.map(({vId , paidAmount}) => ({
      id : vId,
      paidAmount
    })),
    securityConfigItemType : null,
    examOtherChargeId
  };

  // if (cardsPayments?.length > 0) {
  //   request.phoenixNonReceiptedIds = [
  //     ...request.phoenixNonReceiptedIds,
  //     ...cardsPayments.map((item) => item.txnId),
  //   ];
  // }
    if (cardsPayments?.length > 0) {
    request.paymentVoucherDtoList = [
      ...request.paymentVoucherDtoList,
      ...cardsPayments.map(({txnId, paidAmount}) => ({
        id : txnId,
        paidAmount
      })),
    ];
  }
  return request;
};
